/*
 * @Author: dali
 * @Date: 2022-09-28 18:01:30
 * @LastEditors: liuzhezhe
 * @LastEditTime: 2023-08-04 11:16:57
 * @FilePath: \gerlun-react-website\src\pages\product-center\serve\index.jsx
 * @Description:
 */
import React, { useEffect, useRef } from 'react'
import styles from './serve.scss'
import product_1 from '../../../common/images/product/product-1.jpg'
import yd_product1 from '../../../common/images/product/yd-product1.png'
import solution from '../../../common/images/solution/solution.png'
import agencyBookkeeping from '../../../common/images/product/agency-bookkeeping.png'
import advancedBookkeeping from '../../../common/images/product/advanced-bookkeeping.png'
import enterpriseEdition from '../../../common/images/product/enterprise-edition.png'
import cloudReimbursement from '../../../common/images/product/cloud-reimbursement.png'
import electronicSeal from '../../../common/images/product/electronic-seal.png'
import microEnterpriseService from '../../../common/images/product/micro-enterprise-service.png'
import aiInvoicing from '../../../common/images/product/ai-invoicing.png'
import taxReport from '../../../common/images/product/tax-report.png'
import { useNavigate } from 'react-router-dom'

const PRODUCT_CARDS = [
  { name: '代账版', description: ['专为代账公司', '打造'], image: agencyBookkeeping, path: '/product-detail/era-account' },
  { name: '高级代账版', description: ['大型代账公司', '使用'], image: advancedBookkeeping, path: '/product-detail/advanced-era' },
  { name: '企业版', description: ['助力企业', '数字化转型'], image: enterpriseEdition, path: '/product-detail/enterprise' },
  { name: '云报销', description: ['打通报销全流程', '提升企业生产力'], image: cloudReimbursement, path: '/product-detail/reimbursement' },
  { name: '电子签章', description: ['商务拓展场', '合作签署'], image: electronicSeal, warm: true, path: '/product-detail/e-signature' },
  { name: '微企服', description: ['代账公司的', '高效助手'], image: microEnterpriseService, warm: true, path: '/product-detail/micro-service' },
  { name: 'AI开票', description: ['财务流向利器'], image: aiInvoicing, warm: true, path: '/product-detail/ai-invoicing' },
  { name: '税务报告', description: ['促进税务合规', '合理效率纳税'], image: taxReport, warm: true, path: '/product-detail/tax-report' }
]

const Serve = (props) => {
  const navigate = useNavigate()
  const scrollTop = useRef(0)
  const handleScroll = (event) => {
    // 滚动的高度
    scrollTop.current = event.srcElement ? event.srcElement.documentElement.scrollTop : 0
  }
  useEffect(() => {
    const top = sessionStorage.getItem('ServeScrollTop')
    if (top > 0) {
      window.scrollTo({
        top
      })
      sessionStorage.setItem('ServeScrollTop', 0)
    }
    window.addEventListener('scroll', handleScroll)
  }, [])

  const handleNavigate = (path) => {
    if (!path) return
    sessionStorage.setItem('ServeScrollTop', scrollTop.current)
    window.scrollTo({
      top: 0
    })
    navigate(path)
  }
  return <section className={styles['serve']}>
    <div className={styles['serve-contnet']}>
      <div className={styles['product_1']}>
        <img src={product_1} alt='product_1' className={styles['product']} />
        <img src={yd_product1} alt='yd_product1' className={styles['yd_product1']} />
        <div>
          <h2>概而论云记账</h2>
          <p>您的票财税一体化管理专家</p>
        </div>
      </div>
      <div className={styles['introduce']}>
        <img src={solution} alt='solution' className={styles['solution']} />
        <div className={styles['introduce-serve']}>产品服务<h2>，解决不同的场景应用</h2></div>
        <p className={styles['introduce-p']}>点击了解应用场景，选择适合自己的产品</p>
        <ul className={styles['standard']}>
          {PRODUCT_CARDS.map(product => {
            return (
              <li className={`${styles['product-card']} ${product.warm ? styles['product-card-warm'] : ''}`} key={product.name}>
                <a href={product.path || '/#'} onClick={(event) => {
                  event.preventDefault()
                  handleNavigate(product.path)
                }}>
                  <div className={styles['product-card-copy']}>
                    <h3>{product.name}</h3>
                    <p>{product.description.map(line => <span key={line}>{line}</span>)}</p>
                  </div>
                  <div className={styles['product-card-preview']}>
                    <img src={product.image} alt={`${product.name}产品预览`} className={styles['product-card-image']} />
                  </div>
                </a>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  </section>
}

export default Serve
